import { useEffect } from 'react';

import { useToast } from '@motorway/motorway-storybook-cra';

import { INTENT_TYPES } from 'Utilities/FormBase/FormBase.helpers';

const useStoreToast = (storeInstance) => {
	const clearError = storeInstance((store) => store.clearError);
	const { add } = useToast();

	// https://github.com/pmndrs/zustand#transient-updates-for-often-occuring-state-changes
	// Using auto unsubscribe technique here :)
	// Expects a subscribeWithSelector store - To move to TS when zustand is updated
	useEffect(
		() =>
			storeInstance.subscribe(
				(store) => store.error,
				(error) => {
					const { intent, message } = error;
					if (error) {
						add(message, intent || INTENT_TYPES.ERROR, { longMessage: true });
						clearError();
					}
				},
			),
		[add, clearError, storeInstance],
	);

	return null;
};

export default useStoreToast;
